//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "OpacityChoice",

  props: {
    opacity: {
      type: Number,
      default: 100
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onChange(evt) {
      this.$emit('update:opacity', evt)
    }
  },
}
